import { SchemaContext } from "../../common";
import { FieldSchema } from "../../../Schema";
import { LinkedInstance } from "../external-sources/LinkedInstances";
import { User } from "../external-sources/Users";
import { EntryTypes } from "./entryType";
import { Modes } from "./mode";
import { GridFilterTypes } from "../../../grid";
import { getContactPersons } from "../external-sources/ContactPersons";

export const createContactPerson = (context: SchemaContext): FieldSchema => ({
  name: "contactPerson",
  data: { maxLength: 40 },
  display: {
    displayed: true,
  },
  form: {
    label: "Contact person",
    disabled: {
      getter: ({ entryType, linkedInstance, mode, currentUser }) => {
        return (
          [EntryTypes.STANDALONE_EQUIPMENT, EntryTypes.CLUSTER_SUBEQUIPMENT].includes(entryType as EntryTypes) &&
          [Modes.EDIT, Modes.BULK_EDIT].includes(mode as Modes) &&
          ["P1S Uni-Directional"].includes((linkedInstance as LinkedInstance)?.linkedInstance)
        ) && !(currentUser as User)?.isAdmin;
      },
      fields: ["entryType", "linkedInstance", "mode", "currentUser"],
    },
  },
  grid: {
    displayed: true,
    order: 79,
    filter: GridFilterTypes.SET,
    filterValues: { getter: () => getContactPersons(context.client) },
  },
});

export default createContactPerson;